import React from 'react';
import UserDropdown from './UserDropdown';

interface AssigneeDropdownProps {
    label?: string;
    value?: string;
    onChange?: (userId: string) => void;
    error?: string;
    required?: boolean;
    disabled?: boolean;
    placeholder?: string;
}

const AssigneeDropdown = React.forwardRef<HTMLButtonElement, AssigneeDropdownProps>(
    ({
         label = 'Ανατέθηκε σε',
         placeholder = 'Όλοι οι υπεύθυνοι',
         ...props
     }, ref) => {
        return (
            <UserDropdown
                ref={ref}
                label={label}
                placeholder={placeholder}
                assignedToTickets={true}
                filterBlocked={false}
                {...props}
            />
        );
    }
);

AssigneeDropdown.displayName = 'AssigneeDropdown';

export default AssigneeDropdown;
